export const adminSettingsSpecification = {
  title: '관리자 설정',
  purpose: '현재 관리자 계정의 비밀번호를 변경하고, 부계정을 등록·관리하며, 전체 관리자 계정과 최고관리자 지정을 관리하는 화면입니다.',
  functions: [
    '비밀번호 변경 버튼으로 현재 비밀번호를 검증한 뒤 새 비밀번호로 변경합니다.',
    '비밀번호 찾기는 로그인 화면에서 임시 비밀번호를 다시 발급받는 흐름입니다.',
    '가입 승인 대기 목록의 승인·거절은 최고관리자만 처리할 수 있습니다.',
    '최고관리자는 부계정을 직접 등록할 수 있습니다. 등록 시 역할(전체 운영자/콘텐츠 운영자/고객 운영자/조회 전용/맞춤 권한)을 지정하며, 맞춤 권한은 허용 메뉴를 개별 선택합니다.',
    '부계정 관리 목록에서 이름·이메일 검색, 역할·상태 필터로 계정을 조회하고 권한 수정, 사용중지/재개, 삭제를 처리합니다.',
    '전체 관리자 목록에서 계정 상태(승인 대기/사용중/사용중지)와 최고관리자 여부를 확인하고, 최고관리자가 다른 활성 관리자를 최고관리자로 지정하거나 해제할 수 있습니다. 최소 1명의 최고관리자는 항상 유지됩니다.',
    '계정 변경 이력에서 부계정 등록, 권한 수정, 사용중지/재개, 삭제, 최고관리자 지정/해제, 비밀번호 변경 등 모든 관리 작업의 처리자·대상·결과를 확인합니다.',
  ],
  connections: [
    '로그인 화면의 비밀번호 찾기와 같은 관리자 계정 정보를 사용합니다.',
    '허용 메뉴는 좌측 사이드 메뉴 목록과 동일한 항목을 기준으로 합니다.',
    '서비스 공통 등급·카테고리 설정은 별도의 설정 메뉴에서 관리합니다.',
  ],
  app: '사용자 앱 데이터와 직접 연동하지 않으며, 관리자 운영 화면의 접근 보안과 관리자 권한만 관리합니다.',
}

export const adminSettingsDataModelGuide = [
  '관리자 키: admin_id',
  '관리자 권한 구분: is_super_admin (최고관리자 여부). 최소 1명은 항상 유지되어야 합니다.',
  '부계정 역할: role (all/content/customer/viewer/custom), custom일 때만 allowed_menus(JSON 배열)를 사용합니다.',
  '계정 상태: is_active(승인 여부)와 is_suspended(사용중지 여부)를 함께 확인해 승인 대기/사용중/사용중지 3단계로 표시합니다.',
  '계정 변경 이력은 admin.admin_audit_log 테이블에 처리자·대상·작업·결과를 기록합니다.',
  '비밀번호는 원문을 저장하지 않고 argon2 해시로만 저장·검증합니다.',
]

export const adminSettingsImplementationGuide = [
  '화면 식별자: adminSettings. 좌측 사이드 메뉴는 유지하고 메인 영역만 전환합니다.',
  '필수 데이터: 관리자 계정 ID, 역할·허용 메뉴, 계정 상태, 로그인 세션 상태, 변경 이력.',
  '비밀번호 변경은 현재 비밀번호 검증과 새 비밀번호 확인값 일치 후에만 저장합니다.',
  '허용 메뉴 값은 저장·표시 용도로만 사용하며, 좌측 사이드 메뉴 노출이나 라우팅 접근 자체를 실제로 제한하지는 않습니다(후속 과제).',
  '조회 전용 역할은 메뉴 노출 값만 다르게 저장할 뿐, 화면 내 쓰기 액션을 자동으로 막지는 않습니다(후속 과제).',
]
